import React from 'react';
import cn from 'classnames';
import {IconButton} from '../Button';
import DialogTitle, {DialogTitleProps} from './DialogTitle';
import CloseIcon from './CloseIcon';

interface CustomizedDialogTitleProps extends DialogTitleProps {
  onClose?: () => void;
  onBack?: () => void;
  titleClassName?: string;
}

export const CustomizedDialogTitle = ({
  children,
  onClose,
  onBack,
  style,
  className,
  titleClassName,
}: CustomizedDialogTitleProps) => {

  return (
    <DialogTitle
      className={cn(
        'd-flex',
        className?.includes('align-items-') ? '' : 'align-items-center',
        className,
      )}
      style={style}
    >
      <div
        className={cn(
          'd-flex',
          titleClassName?.includes('align-items-') ? '' : 'align-items-center',
          titleClassName,
        )}
      >
        {onBack ? (
          <IconButton className="mr-3" onClick={onBack}>
            <span className="tg-icon-chevron-left-line icon-size-18 color-body-primary" />
          </IconButton>
        ) : null}
        {children}
      </div>
      {onClose ? (
        <IconButton className="ml-auto" onClick={onClose}>
          <CloseIcon className="icon-size-18 color-body-primary" />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default CustomizedDialogTitle;
